import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, BookOpen, Users, ShoppingCart, Sparkles, Tag, Ticket, Package, Mail, KeyRound, MapPin } from "lucide-react";
import { api } from "@/lib/api";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/courses", label: "Courses", icon: BookOpen },
  { to: "/admin/ai-generator", label: "AI Course Generator", icon: Sparkles },
  { to: "/admin/bundles", label: "Bundles", icon: Package },
  { to: "/admin/coupons", label: "Coupons", icon: Ticket },
  { to: "/admin/digest", label: "Weekly Digest", icon: Mail },
  { to: "/admin/tutor", label: "Tutoring", icon: Sparkles },
  { to: "/admin/centre", label: "Learning Centre", icon: MapPin },
  { to: "/admin/partners", label: "Training Partners", icon: Users },
  { to: "/admin/demo", label: "Demo Accounts", icon: KeyRound },
  { to: "/admin/students", label: "Students", icon: Users },
  { to: "/admin/sales", label: "Sales", icon: ShoppingCart },
  { to: "/admin/categories", label: "Categories", icon: Tag },
];

export default function AdminLayout() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-8 grid lg:grid-cols-12 gap-6">
      <aside className="lg:col-span-3">
        <div className="bg-white border border-[#E5E7EB] rounded-xl p-4 sticky top-24">
          <div className="label-eyebrow text-[#064E3B]">Admin</div>
          <div className="font-display font-bold text-lg mt-1">Control Room</div>
          <nav className="mt-4 space-y-1">
            {NAV.map((n) => {
              const Icon = n.icon;
              return (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.end}
                  data-testid={`admin-nav-${n.label.toLowerCase().replace(/ /g,"-")}`}
                  className={({isActive}) => `flex items-center gap-2 px-3 py-2 rounded-md text-sm font-semibold transition-colors ${isActive ? "bg-[#FECACA]/40 text-[#7F1D1D]" : "hover:bg-[#F3F4F6]"}`}
                >
                  <Icon className="w-4 h-4" /> {n.label}
                </NavLink>
              );
            })}
          </nav>
        </div>
      </aside>
      <main className="lg:col-span-9">
        <Outlet />
      </main>
    </div>
  );
}
